module.exports = __webpack_public_path__ + "images/corners/Circuit.fe6b321ba3209a7c267ae51149550d76.jpg";